import React, { useContext } from "react";
import PBint from "../productPages/PBint";
import PFsa from "../productPages/PFsa";
import PVsa from "../productPages/PVsa";
import PHfsp from "../productPages/PHfsp";
import PFsbi from "../productPages/PFsbi";
import { data as DATA_PRODUCTS } from "../DATA_PRODUCTS";

import OpacityContext from "../OpacityContext";

// import "../productPages/pageAndProductStyle.css";

export default function PagePFD({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  const { productIndex } = useContext(OpacityContext);

  // Map product label to component
  const componentMap = {
    bint: PBint,
    fsa: PFsa,
    fsbi: PFsbi,
    hfsp: PHfsp,
    vsa: PVsa
  };
  //* get the label name based on productIndex
  const label =
    DATA_PRODUCTS[productIndex] && DATA_PRODUCTS[productIndex].label; //* this is mapping the label to the data with a safe check bc our compiler doesn't support optional chaining

  //* We will create a dynamic component that gets selected and we will render out just that instead of listing out conditional renders for each one
  const ProductComponent = componentMap[label];

  return (
    <div className="pageContainer pageContainerPFD">
      {ProductComponent && (
        <ProductComponent
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      )}
    </div>
  );
}

/*
  return (
    <div className="pageContainer pageContainerPFD">
      {productIndex === 0 ? (
        <PBint
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 1 ? (
        <PFsa
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 2 ? (
        <PHfsp
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 3 ? (
        <PVsa
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
      {productIndex === 4 ? (
        <PFsbi
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      ) : null}
    </div>
  );
}
*/
